import { render, staticRenderFns } from "./sdksPop.vue?vue&type=template&id=8a763e88&scoped=true&"
import script from "./sdksPop.vue?vue&type=script&lang=js&"
export * from "./sdksPop.vue?vue&type=script&lang=js&"
import style0 from "./sdksPop.vue?vue&type=style&index=0&id=8a763e88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a763e88",
  null
  
)

export default component.exports